
<section id="all-users" class="item-grid-container">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="grid-top-actions search-holder">
          <ul class="list-inline grid-top-actions mt-1 mb-0">
            <li class="list-inline-item ">
              <input
                type="text"
                placeholder="{{ 'pages.newRetailer.search' | translate }}"
                matInput
                class="
                  rounded-pill
                  px-3
                  py-2
                  mb-0
                  border-0
                  bg-light
                  w-100
                  me-0
                  input-search
                  ms-3
                "
                (keyup)="quickSearch()"
                [(ngModel)]="searchValue"
              />
              <i
                color="primary"
                class="search-icon-holder"
                matSuffix
                mat-icon-button
                aria-label="Search"
              >
                <mat-icon>search</mat-icon>
              </i>
            </li>
  
            <li class="list-inline-item float-end">
              <button [disabled]="isButtonDisabled" mat-stroked-button class="" (click)="exportData()">
                <span translate class="translate"
                  >pages.newRetailer.download</span
                >
                <i class="mi mi-save-alt"></i>
              </button>
            </li>
            <li class="list-inline-item float-end mx-2" [ngStyle]="{'display': userRole === 'Super Admin' || userRole === 'Sub Admin' || userRole === 'Customer Service' ? 'block':'none'}">
              <button
                mat-stroked-button
                [disabled]="showUpdateUser"
                class=""
                (click)="updateUser()"
                
              >
                {{ "pages.newRetailer.edit" | translate }}
                <i class="mi mi-drive-file-rename-outline"></i>
              </button>
            </li>
          </ul>
        </div>
        <div class="grid-container">
          <div class="item-grid-container">
            <ag-grid-angular
              style="width: 100%; height: 65vh"
              class="ag-theme-material"
              [rowHeight]="40"
              [enableFilter]="true"
              [enableSorting]="true"
              [enableColResize]="true"
              [rowSelection]="rowSelection"
              [rowData]="rowData"
              [columnDefs]="columnDefs"
              (gridReady)="onGridReady($event)"
              (selectionChanged)="onSelectionChanged($event)"
            >
            </ag-grid-angular>
          </div>
        </div>
      </div>
    </div>
  </section>
  